import * as React from "react";

const ImageComponent = ({ imageUrl, alt = '' }) => {
    return (
        <img src={imageUrl}
             alt={alt}
             style={{ maxWidth: '100%', height: 'auto', width:"inherit" }}
             loading="lazy"
        />
    );
};

export default ImageComponent;